
// Import images
import widgetBackground from './images/claudia-background.svg'
import widgetAvatar from './images/claudia-avatar-v2.png'
import widgetIcon from './images/claudia-avatar-v3.png'
import widgetBackgroundWhatsapp from './images/claudia-background-whatsapp.png'

// Import icons
import closeIcon from './images/close.svg'
import sendIcon from './images/send.svg'
import backIcon from './images/exit.svg'

// Import styles
import mainStyle from './styles/main.scss'

// Import templates
import switchTemplate from './templates/switch.mst'
import widgetTemplate from './templates/widget.mst'
import messageTemplate from './templates/message.mst'
import spinnerTemplate from './templates/spinner.mst'
import switchWhatsappTemplate from './templates/switch-whatsapp.mst'

const assets = {
  images: {
    'avatar': widgetAvatar,
    'wgt': {
      background: widgetBackground,
      icon: widgetIcon,
      iconWhatsapp: widgetBackgroundWhatsapp
    }
  },
  icons: {
    'close': closeIcon,
    'send': sendIcon,
    'back': backIcon
  },
  styles: {
    'main': mainStyle
  },
  templates: {
    'switch': switchTemplate,
    'widget': widgetTemplate,
    'message': messageTemplate,
    'spinner': spinnerTemplate,
    'switch-whatsapp': switchWhatsappTemplate
  }
}

export default assets
